import React from "react";

export default function Loading() {
  return (
    <div className="loadingScreen">
      <div className="loader"></div>
      <span>Loading...</span>
    </div>
  );
}
